// BOOT_VISION_CONSTANTS is injected by the backend.
// This way we don't need to keep these constants in sync with the backend manually.
import constants from '../../lib/constants'

export const PAYMENT_METHOD_CREDIT_CARD = 'cc'
export const PAYMENT_METHOD_CASH = 'cash'

export default constants
